import {
  FETCH_BREADCRUMBS_CHILD_CATEGORIES_SUCCESS,
  FETCH_BREADCRUMBS_CHILD_CATEGORIES_ERROR,
} from '../actions/breadcrumbs';

export const initialState = {
  catalogue: {
    childCategories: {},
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BREADCRUMBS_CHILD_CATEGORIES_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        catalogue: {
          ...state.catalogue,
          childCategories: data,
        },
      };
    }
    case FETCH_BREADCRUMBS_CHILD_CATEGORIES_ERROR: {
      return {
        catalogue: {
          ...initialState.catalogue,
          error: action.error,
        },
      };
    }
    default:
      return state;
  }
};
